import 'bulma/css/bulma.css';
import './src/components/ui/animations.scss';
import React from 'react';
import { ToastProvider } from './src/components/ui/ToastProvider';
import { AuthProvider } from './src/context/AuthContext';

// Wrap the entire app with ToastProvider
export const wrapRootElement = ({ element }) => {
  return <AuthProvider><ToastProvider>{element}</ToastProvider></AuthProvider>;
};
